export const getCurrentSiteConfig = () => {

  // 从环境变量获取当前站点ID
  const siteId = process.env.SITE_PROFILE || 'de'
    // 环境映射：将 NODE_ENV 映射到正确的目录名
    // development -> development, release -> release, production -> production
    // 如果未设置或为其他值，默认使用 development
    let env = process.env.NODE_ENV || 'development'
    if (env === 'dev') {
        env = 'development'
    }

  try {
    // 动态导入对应站点的配置
        return import(`../configs/${env}/site.${siteId}.js`).then(m => {
            return m.default
        })
  } catch (error) {
        console.error(`[SiteConfig] 加载配置失败: siteId=${siteId}, env=${env}`, error)
        // 如果加载失败，尝试使用 development 环境作为后备
        if (env !== 'development') {
            try {
                return import(`../configs/development/site.${siteId}.js`).then(m => {
                    return m.default
                })
            } catch (fallbackError) {
                return import(`../configs/development/site.de.js`).then(m => m.default)
            }
        }
        return import(`../configs/development/site.de.js`).then(m => m.default)
  }
}

export const getSiteConfigByProfile = (profile) => {

  // 从环境变量获取当前站点ID
  const siteId = profile
    // 环境映射：将 NODE_ENV 映射到正确的目录名
    let env = process.env.NODE_ENV || 'development'
    if (env === 'dev') {
        env = 'development'
    }
    
  try {
    // 动态导入对应站点的配置
    return import(`../configs/${env}/site.${siteId}.js`).then(m => m.default)
  } catch (error) {
        console.error(`[SiteConfig] Failed to load config for site: ${siteId}, env: ${env}`, error)
        // 如果加载失败，尝试使用 development 环境作为后备
        if (env !== 'development') {
            try {
                return import(`../configs/development/site.${siteId}.js`).then(m => m.default)
            } catch (fallbackError) {
                console.error(`[SiteConfig] Failed to load fallback config for site: ${siteId}`, fallbackError)
                return import(`../configs/development/site.de.js`).then(m => m.default)
            }
        }
        return import(`../configs/development/site.de.js`).then(m => m.default)
  }
}

// 在应用启动时设置站点配置
export const initSiteConfig = async (app) => {

  const config = await getCurrentSiteConfig()
  
  app.config.globalProperties.$site = config
  
  // 设置HTML lang属性
  document.documentElement.lang = config.language
  
  return config
}
